import { postJson } from '../ChoiceApi';

import { IActiveReportReceiptInputs, IActiveReportResponse } from '../Models/ActiveReportModel';

export async function Receipt(payload: IActiveReportReceiptInputs): Promise<IActiveReportResponse> {
    return (await postJson("api/activeReport/Receipt", payload)) as IActiveReportResponse;
}
